import { Injectable } from '@angular/core';
import { ResourceBaseUrlBuilder } from '@core/api/resource-base-url-builder';
import { UserNamespacedResourceBaseUrlBuilder } from '@core/user-namespaced-resource-base-url-builder.service';
import { standardizeUrl } from '@core/utils';

@Injectable({ providedIn: 'root' })
export class UserDataroomResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(private readonly userNamespacedBuilder: UserNamespacedResourceBaseUrlBuilder) {}

  public buildBaseUrl(): string {
    const url = this.userNamespacedBuilder.buildBaseUrl();

    return standardizeUrl(url);
  }
}
